<script setup>
import AppSidebar from "@/components/layout/AppSidebar.vue";
import AppTopbar from "@/components/layout/AppTopbar.vue";
</script>
<template>
  <div class="d-flex bg-light" style="height: 100vh; overflow: hidden">
    <AppSidebar />

    <div
      class="flex-grow-1 d-flex flex-column"
      style="min-width: 0; overflow: hidden"
    >
      <AppTopbar />
      <main class="p-4 flex-grow-1" style="overflow-y: auto">
        <slot />
      </main>
    </div>
  </div>
</template>
